/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const selectQuiz = state => state.quiz;
